import React from 'react';
import styles from './A23RecommendedTile.module.css';
import gameAssets from '@themed-assets';
import { GAME_TYPE_MAP, RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { useNavigate } from 'react-router';
import useGameDefinition from '@/src/hooks/data/useGameDefinition';
import { FaChevronRight } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { showBuyInPopupInLobby } from '@/Poker/redux/slices/lobbySlice';
import useRoomDetails from '@/src/hooks/data/useRoomDetails';

const A23RecommendedTile = ({ gameDefId, index }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gameDefinition = useGameDefinition(gameDefId);
    const roomDetails = useRoomDetails(gameDefinition.roomId);

    // Check if game definition exists and is active
    if (!gameDefinition || !gameDefinition.gameDefId || gameDefinition.status?.toLowerCase() !== 'active') {
        return null;
    }

    const handleGameTileClick = () => {
        if (roomDetails.isTableListingEnabled) {
            return navigate(`/cashLobbyRoom/${roomDetails.roomId}`);
        } else {
            if (gameDefinition) {
                return dispatch(showBuyInPopupInLobby({ gameDefinition }));
            } else {
                console.warn('Error in clicking on game tile. No game definition available.')
            }
        }
    }

    return (
        <div onClick={handleGameTileClick} className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerTitle}>
                    {index === 0 ? 'MOST PLAYED' : 'RECOMMENDED'}
                </div>
                <div className={styles.headerGameType}>
                    <span className={styles.gameTypeText}>{GAME_TYPE_MAP[gameDefinition.gameType]}</span>
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.blindsRow}>
                    <img className={styles.cashIcon} src={gameAssets.cashIcon} alt="Blinds amount" />
                    <span>{gameDefinition.smallBlind} / {gameDefinition.bigBlind}</span>
                </div>
                <div className={styles.infoRow}>
                    <div className={styles.infoItem}>
                        <img src={gameAssets.userIcon} alt="Number of players" />
                        <span className={styles.infoValue}>{gameDefinition.onlineCount}</span>
                    </div>
                    <div className={styles.infoItem}>
                        <span>Min Buy <span className={styles.infoValue}>{RUPEE_SYMBOL + gameDefinition.minBuyInAmount}</span></span>
                        <FaChevronRight color='var(--color-secondary)' size={12} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default A23RecommendedTile; 